import { AUTO_FILLED_PLACEHOLDER } from "@/features/company/constants/sections";
import { Input, TInputProps } from "@/modules/irohana-components/elements/Input";
import { text } from "@/theme/colors";
import { styled } from "@mui/material";
import { FC } from "react";

/**
 * 郵便番号 から自動入力される readonly 項目（都道府県・市区町村）。
 * 共有 Input は readonly 時に placeholder を opacity: 0 で消してしまうため、
 * ここだけ 灰色背景でも読める濃さ（text.secondary）で戻す。
 */
export const AutoFilledInput: FC<TInputProps> = (props) => (
  <StyledAutoFilledInput fullWidth readonly clearable={false} placeholder={AUTO_FILLED_PLACEHOLDER} {...props} />
);

const StyledAutoFilledInput = styled(Input)`
  .MuiInputBase-root input::placeholder {
    opacity: 1 !important;
    color: ${text.secondary} !important;
    -webkit-text-fill-color: ${text.secondary};
  }
`;
